import type { ReactNode } from 'react'

import { CardList, Title, Wrapper } from './styles'

interface SiGunGuGroupProps {
  /** 시군구 이름 (예: "고양시", "광명시") */
  name: string
  /** 시군구 하위 DongAccordion 카드들 */
  children: ReactNode
  /**
   * 시군구 헤더("고양시") 노출 여부.
   *
   * 인천(피그마 17740:44638)은 시군구 wrapper 헤더를 그리지 않고 DongAccordion 카드만 평면 나열.
   * DongAccordion 카드 헤더 자체에 시군구 이름이 들어가므로 이중 표시 방지.
   * 다른 시도(경기 등)는 기본값(true)로 헤더 노출.
   */
  showTitle?: boolean
  /**
   * 그룹 wrapper DOM id — 지도 라벨 클릭 시 scrollIntoView 타겟.
   * scroll-margin-top 이 wrapper 에 적용돼 sticky Tabs 아래 일정 gap 으로 정렬됨.
   */
  id?: string
}

/**
 * 시군구 단위 그룹 — 헤더(시군구 이름) + 자식 카드들.
 *
 * 자식 카드 케이스:
 *  - 일반구 보유 시: DongAccordion N개 (덕양구·일산동구...)
 *  - 일반구 없음: DongAccordion 1개 (시군구 이름 라벨)
 *  - 시군구 isFullCoverage 정적 카드(경기): SiGunGuChildren 에서 별도 처리
 */
export default function SiGunGuGroup({ name, children, showTitle = true, id }: SiGunGuGroupProps) {
  return (
    <Wrapper id={id}>
      {showTitle && <Title>{name}</Title>}
      <CardList>{children}</CardList>
    </Wrapper>
  )
}
